import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.date.now";
import _classCallCheck from "/home/csaba/workspace/componently/portfolio-with-componently/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/csaba/workspace/componently/portfolio-with-componently/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/csaba/workspace/componently/portfolio-with-componently/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/csaba/workspace/componently/portfolio-with-componently/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/csaba/workspace/componently/portfolio-with-componently/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { SplitFactory as SplitSDK } from '@splitsoftware/splitio';
import React from 'react';
import SplitContext from './SplitContext';
import { VERSION, WARN_SF_CONFIG_AND_FACTORY, ERROR_SF_NO_CONFIG_AND_FACTORY } from './constants';
import { getClientWithStatus } from './utils';
/**
 * SplitFactory will initialize the Split SDK and listen for its events in order to update the Split Context.
 * SplitFactory must wrap other components and functions from this library, since they access the Split Context
 * and its elements (factory, clients, etc).
 *
 * @see {@link https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK}
 */

var SplitFactory = /*#__PURE__*/function (_React$Component) {
  _inherits(SplitFactory, _React$Component);

  var _super = _createSuper(SplitFactory);

  function SplitFactory(props) {
    var _this;

    _classCallCheck(this, SplitFactory);

    _this = _super.call(this, props);

    _this.sdkUpdate = function () {
      _this.setState({
        lastUpdate: Date.now()
      });
    }; // Log warning and error


    var propFactory = props.factory,
        config = props.config,
        updateOnSdkReady = props.updateOnSdkReady,
        updateOnSdkTimedout = props.updateOnSdkTimedout,
        updateOnSdkUpdate = props.updateOnSdkUpdate;

    if (!config && !propFactory) {
      console.error(ERROR_SF_NO_CONFIG_AND_FACTORY);
    }

    if (config && propFactory) {
      console.log(WARN_SF_CONFIG_AND_FACTORY);
    } // Instantiate factory and main client.


    var factory = propFactory || (config ? SplitSDK(config) : null); // Don't try this at home. Only override the version when we create our own factory.

    if (config && factory) {
      factory.settings.version = VERSION;
    }

    var client = factory ? getClientWithStatus(factory) : null;

    if (client) {
      _this.subscribeToEvents(client, updateOnSdkUpdate, updateOnSdkTimedout, updateOnSdkReady);
    }

    _this.state = {
      client: client,
      factory: factory,
      isReady: client ? client.isReady : false,
      isTimedout: client ? client.isTimedout : false,
      lastUpdate: 0
    };
    return _this;
  } // Listen SDK events. This method will be updated when SDK provides self synchronous status


  _createClass(SplitFactory, [{
    key: "subscribeToEvents",
    value: function subscribeToEvents(client, updateOnSdkUpdate, updateOnSdkTimedout, updateOnSdkReady) {
      var _this2 = this;

      if (!client.isReady) {
        // client is not ready

        /**
         * client still might be ready if it was created before using `getClientWithStatus` function
         * (for example if the client was instantiated outside SplitClient),
         * thus we have to use the ready() promise instead of an event listener.
         */
        client.ready().then(function () {
          // Update isReady if the client was not changed and updateOnSdkReady is true
          if (_this2.state.client === client && updateOnSdkReady) {
            _this2.setState({
              isReady: true,
              isTimedout: false,
              lastUpdate: Date.now()
            });
          }
        }, function () {
          // Update isTimedout if the client was not changed and updateOnSdkTimedout is true
          if (_this2.state.client === client) {
            if (updateOnSdkTimedout) {
              _this2.setState({
                isTimedout: true,
                lastUpdate: Date.now()
              });
            } // register a listener for SDK_READY event, that might trigger after a timeout


            client.once(client.Event.SDK_READY, function () {
              // Update isReady if the client was not changed and updateOnSdkReady is true
              if (_this2.state.client === client && updateOnSdkReady) {
                _this2.setState({
                  isReady: true,
                  isTimedout: false,
                  lastUpdate: Date.now()
                });
              }
            });
          }
        });
      } // register a listener for SDK_UPDATE event


      if (updateOnSdkUpdate) {
        client.on(client.Event.SDK_UPDATE, this.sdkUpdate);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          factory = _this$state.factory,
          isReady = _this$state.isReady,
          isTimedout = _this$state.isTimedout,
          lastUpdate = _this$state.lastUpdate;
      return React.createElement(SplitContext.Provider, {
        value: this.state
      }, typeof children === 'function' ? children({
        factory: factory,
        isReady: isReady,
        isTimedout: isTimedout,
        lastUpdate: lastUpdate
      }) : this.props.children);
    }
  }]);

  return SplitFactory;
}(React.Component);

SplitFactory.defaultProps = {
  updateOnSdkUpdate: false,
  updateOnSdkTimedout: false,
  updateOnSdkReady: true,
  children: null
};
export default SplitFactory;